<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Usuarios</h1>
        </div>
        <div class="ctn_general">
            <!-- Aquí el contenido -->
            <div class="tabla_ctn">
                <div class="tabla_filtros">
                    <Filters :data="filterData" label="Filtrar usuarios" @onFilter="onFilter"/>
                    <div class="tfiltros_col xs right mOrder1 nowrap">
                        <div class="mdi mdi-magnify input_search mobileOrder3">
                            <form @submit.prevent="search">
                                <input type="search" placeholder="Buscar por nombres, apellidos o usuario"
                                       v-model="keyword">
                            </form>
                        </div>
                        <form action="" class="mobileOrder2">
                            <router-link tag="a" class="btn" :to="{name:'user-creator'}">Agregar usuario
                            </router-link>
                        </form>
                    </div>
                </div>

                <div class="tabla_scroll">
                    <table class="lProducto con_options">
                        <thead>
                        <tr>
                            <th>Usuario</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Celular</th>
                            <th>Perfil</th>
                            <th>Fecha de creación</th>
                            <th>Fecha de modificación</th>
                            <th>Estado</th>
                            <th class="d_option"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="u in users">
                            <td>{{u.username}}</td>
                            <td>{{u.firstName}}</td>
                            <td>{{u.lastName}}</td>
                            <td style="text-align: center;">{{u.phone}}</td>
                            <td style="text-align: center;">{{u.profile}}</td>
                            <td style="text-align: center;" v-date-local="u.createdAt"></td>
                            <td style="text-align: center;" v-date-local="u.updatedAt"></td>
                            <td style="text-align: center;"><span :class="`budget ${getStatusStr(u.status).color}`">{{getStatusStr(u.status).value}}</span>
                            </td>
                            <td class="d_option">
                                <i class="mdi mdi-dots-vertical"></i>
                                <span class="drop_options estados_pedido">
									<span @click="edit(u)">Editar usuario</span>
                                    <span @click="changeStatus(u)">{{u.status === 2 ? "Activar" : "Suspender"}}</span>
								</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Paginator :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
                           :changePageSize="changePageSize"/>
            </div>
        </div>
    </div>
</template>
<script>

    import {userStatuses} from '../../util/options'
    import Paginator from '../common/Paginator.vue'
    import {loading} from '../../util/util'
    import {paginatorMixin} from '../../util/paginatorMixin'
    import Filters from '../common/Filters.vue'
    import UserService from "../../services/UserService";
    import alert from '../../util/alert'

    export default {
        components: {
            Paginator,
            Filters
        },
        data() {
            return {
                users: [],
                selectedUser: null,
                keyword: null,
                filters: [],
                filterData: [{key: 'status', label: 'Estado', type: 'single', items: userStatuses}]
            }
        },
        mixins: [paginatorMixin],
        computed: {},
        methods: {
            getStatusStr(status) {
                return userStatuses.find((s) => s.key === status);
            },
            changePage(p) {
                const self = this;
                self.page = p;
                self.listUsers(p, self.pageSize)
            },
            changePageSize(pageSize) {
                const self = this;
                this.page = 1;
                this.pageSize = pageSize;
                self.listUsers(1, pageSize)
            },
            async listUsers(page, pageSize) {
                loading(true);
                const self = this;
                const params = {page: page - 1, size: pageSize};
                if (self.keyword)
                    params.keyword = self.keyword;

                if (self.filters && self.filters.length > 0) {
                    self.filters.forEach(it => {
                        let opts;
                        if (it.data instanceof Array) {
                            opts = [];
                            it.data.forEach(o => {
                                opts.push(o.key);
                            })
                        } else {
                            opts = it.data.key;
                        }
                        params[it.key] = opts;
                    })
                }

                const resp = (await UserService.list(params)).data.payload;
                self.users = resp.content;
                self.total = resp.totalElements;
                self.pages = resp.totalPages;
                loading(false);
            },
            search() {
                const self = this;
                self.page = 1;
                self.listUsers(self.page, self.pageSize);
            },
            edit(user) {
                this.$router.push({name: 'user-editor', params: {userId: user.id}});
            },
            changeStatus(userIn) {
                const self = this;
                alert.dialog('¿Desea cambiar el estado del usuario?',
                    null,
                    async function () {
                        try {
                            loading(true);
                            const resp = (await UserService.toggleStatus(userIn.id)).data.payload;
                            const user = self.users.find((o) => {
                                return o.id === resp.id;
                            });
                            if (user) {
                                const index = self.users.indexOf(user);
                                self.$set(self.users, index, resp);
                            }
                            alert.success("Usuario actualizado correctamente.");
                        } catch (e) {
                            console.error(e);
                            alert.error("Error actualizando usuario")
                        } finally {
                            loading(false);
                        }
                    });
            },
            onUpdated(prod) {
                const self = this;
                const userFiltered = self.users.find((p) => {
                    return p.id === prod.id;
                });
                self.selectedUser = null;
                if (userFiltered) {
                    const index = self.users.indexOf(userFiltered);
                    self.$set(self.users, index, prod);
                }
            },
            onClosed() {
                this.selectedUser = null;
            },
            onFilter(data) {
                const self = this;
                self.filters = data;
                self.page = 1;
                self.listUsers(self.page, self.pageSize);

            },
        },
        async mounted() {
            const self = this;
            self.listUsers();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/users/Users.vue